module.exports = __webpack_public_path__ + "img/pricing-info-mobile@2x.8c6352b8.webp";